var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLineChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.75 24.75H6.25V5.25C6.25 5.1125 6.1375 5 6 5H4.25C4.1125 5 4 5.1125 4 5.25V26.75C4 26.8875 4.1125 27 4.25 27H27.75C27.8875 27 28 26.8875 28 26.75V25C28 24.8625 27.8875 24.75 27.75 24.75ZM9.55625 19.9281C9.65312 20.025 9.80938 20.025 9.90938 19.9281L14.2312 15.6281L18.2188 19.6406C18.3156 19.7375 18.475 19.7375 18.5719 19.6406L27.1781 11.0375C27.275 10.9406 27.275 10.7812 27.1781 10.6844L25.9406 9.44687C25.8936 9.40035 25.8302 9.37425 25.7641 9.37425C25.6979 9.37425 25.6345 9.40035 25.5875 9.44687L18.4 16.6313L14.4187 12.625C14.3718 12.5785 14.3083 12.5524 14.2422 12.5524C14.1761 12.5524 14.1126 12.5785 14.0656 12.625L8.32187 18.3344C8.27535 18.3814 8.24925 18.4448 8.24925 18.5109C8.24925 18.5771 8.27535 18.6405 8.32187 18.6875L9.55625 19.9281Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineChart);
export default __webpack_public_path__ + "static/media/lineChart.85071b68df7e58323b09d4007635d99e.svg";
export { ForwardRef as ReactComponent };